const pageNameKey = "machinesListHeaderExpandCollapseAll";

export const machinesListHeaderExpandCollapseAllEn = {
  [pageNameKey]: {
    addFilter: "Add Filter",
    companies: "Companies",
    expandAll: "Expand All",
    closeAll: "Close All",
  },
};

export const machinesListHeaderExpandCollapseAllPtBr = {
  [pageNameKey]: {
    addFilter: "Adicionar filtro",
    companies: "Empresas",
    expandAll: "Expandir tudo",
    closeAll: "Fechar tudo",
  },
};

export const machinesListHeaderExpandCollapseAllDe = {
  [pageNameKey]: {
    addFilter: "Filter hinzufügen",
    companies: "Unternehmen",
    expandAll: "Alle erweitern",
    closeAll: "Alle schließen",
  },
};

export const machinesListHeaderExpandCollapseAllZhHans = {
  [pageNameKey]: {
    addFilter: "添加过滤器",
    companies: "公司",
    expandAll: "全部展开",
    closeAll: "全部关闭",
  },
};

export const machinesListHeaderExpandCollapseAllIt = {
  [pageNameKey]: {
    addFilter: "Aggiungi filtro",
    companies: "Aziende",
    expandAll: "Espandi tutto",
    closeAll: "Riduci tutto",
  },
};

export const machinesListHeaderExpandCollapseAllEs = {
  [pageNameKey]: {
    addFilter: "Agregar filtro",
    companies: "Empresas",
    expandAll: "Expandir todo",
    closeAll: "Cerrar todo",
  },
};

export const machinesListHeaderExpandCollapseAllNl = {
  [pageNameKey]: {
    addFilter: "Filter toevoegen",
    closeAll: "Alles sluiten",
    companies: "Bedrijven",
    expandAll: "Alles uitvouwen",
  },
};

export const machinesListHeaderExpandCollapseAllTr = {
  [pageNameKey]: {
    addFilter: "Filtre Ekle",
    closeAll: "Tümünü Kapat",
    companies: "Şirketler",
    expandAll: "Tümünü Genişlet",
  },
};
